module.exports = __webpack_public_path__ + "img/sun.da281df3.png";